import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef, useContext } from 'react';

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';

import '../../css/listBots.css';

import BotsIntegrations from '../../integrations/BotsIntegrations';
import { EnvContext } from '../Context/EnvProvider';

import { useAuth0 } from "@auth0/auth0-react";
import { useAuthToken } from '../../hooks/useAuthToken';

const botsIntegrations = new BotsIntegrations();


const ListBots = () => {

    const [bots, setBots] = useState(null);
    const [rowBot, setRowBot] = useState(null);
    const [rowTenant, setRowTenant] = useState(null);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const [deleteDialog, setDeleteDialog] = useState(null);
    const [deleteTenantDialog, setDeleteTenantDialog] = useState(null);
    const { user, isAuthenticated } = useAuth0();
    const { getAccessToken } = useAuthToken();

    const { environment } = useContext(EnvContext);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        setLoading(true);
        getAccessToken()
            .then((authToken) => botsIntegrations.listBots(environment.listBots, user.email, authToken))
            .then(data => {
                setBots(data);
                setLoading(false);
                setReload(false);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
                setReload(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: 'Erro ao carregar bots.',
                    life: 5000,
                });
            });
    }, [reload, environment, isAuthenticated, getAccessToken, user.email]);

    const confirmDeleteBot = (rowData) => {
        setRowBot(rowData);
        setDeleteDialog(true);
    }
    const confirmDeleteTenant = (rowData) => {
        setRowTenant(rowData);
        setDeleteTenantDialog(true);
    }
    const deleteBot = async () => {
        try {
            const authToken = await getAccessToken();
            await botsIntegrations.deleteBot(environment.botApi, rowBot.id, authToken, environment.apiKey);
            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Bot Excluido!', life: 3000 });
            setDeleteDialog(false);
            setReload(true);
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao deletar bot.', life: 5000 });
        }
    }
    const deleteTenant = async () => {
        setLoadingButton(true);
        try {
            const authToken = await getAccessToken();
            await botsIntegrations.deleteTenant(environment.botApi, rowTenant.tenantId, authToken);
            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Tenant excluído!', life: 3000 });
            setDeleteTenantDialog(false);
            setReload(true);
            setLoadingButton(false);
        } catch (error) {
            setLoadingButton(false);
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao deletar tenant.', life: 5000 });
        }
    }
    const hidedeleteDialog = () => {
        setDeleteDialog(false);
    }
    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteBot} />
        </React.Fragment>
    );

    const hidedeleteTenantDialog = () => {
        setDeleteTenantDialog(false);
    }
    const deleteTenantDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteTenantDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteTenant} loading={loadingButton} />
        </React.Fragment>
    );

    const header = (
        <div className="table-header">
            <h5 className="p-mx-0 p-my-1">Procurar Bots</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
            </span>
        </div>
    );
    const rowExpansionTemplate = (rowData) => {
        return (
            <div className="orders-subtable">
                <div className="p-fluid p-grid">
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-pencil"
                            label="MODELS"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                window.open(environment.dashboard + '/Models?botId=' + rowData.id, "_blank")
                            }
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-cog"
                            label="CONFIGURAÇÕES"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                window.open(environment.dashboard + '/BotParamsConfig?botId=' + rowData.id + '&botName=' + rowData.botName, "_blank")
                            }
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-sitemap"
                            label="INTEGRAÇÕES"
                            className="p-button-rounded p-button-secondary"
                            onClick={() => window.open(environment.dashboard + '/Integrations?botId=' + rowData.id + '&botName=' + rowData.botName, "_blank")}
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-android"
                            label="TESTE"
                            className="p-button-rounded p-button-secondary"
                            onClick={() => {
                                const { id } = rowData;
                                const { email } = user;
                                const url = `${environment.chat}/?clientId=${encodeURIComponent(id)}&email=${encodeURIComponent(email)}&token=teste1234`;
                                window.open(url, "_blank");
                              }}
                              
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-trash"
                            label="EXCLUIR"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                confirmDeleteBot(rowData)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-mr-2"
                    onClick={() => confirmDeleteTenant(rowData)}
                />
            </React.Fragment>
        );
    };

    return (
        <div className="listBot">
            <Toast ref={toast} />
            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Lista de Bots</span>
                        </li>
                    </ol>
                </nav>
            </div>

            <div className="card">

                <DataTable value={bots}
                    expandedRows={expandedRows}
                    paginator
                    rows={10}
                    loading={loading}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords} Bots"
                    emptyMessage="Nenhum bot encontrado!"
                    rowExpansionTemplate={rowExpansionTemplate}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    dataKey="id"
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll"
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column field="botName" header="Nome do Bot" sortable style={{ width: '100%', minWidth: '15rem' }}></Column>
                    <Column field="templateId" header="Template ID" sortable style={{ width: '100%', minWidth: '12rem' }}></Column>
                    <Column field="tenantId" header="Tenant ID" sortable style={{ width: '100%', minWidth: '12rem' }}></Column>
                    <Column header="Deletar Tenant" body={actionBodyTemplate}></Column>
                </DataTable>
            </div>
            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Confirme" modal footer={deleteDialogFooter} onHide={hidedeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {rowBot && <span>Tem certeza de que deseja excluir o bot: <b>{rowBot.botName}</b>?</span>}
                </div>
            </Dialog>
            <Dialog visible={deleteTenantDialog} style={{ width: '450px' }} header="Confirme" modal footer={deleteTenantDialogFooter} onHide={hidedeleteTenantDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {rowTenant && <span>Tem certeza de que deseja excluir todos os dados do Tenant: <b>{rowTenant.tenantId}</b>?</span>}
                </div>
            </Dialog>
        </div>
    );
}
export default ListBots;
